import React from "react";
import Card from "react-bootstrap/Card";
import { Button, Container, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const Tables = () => {
  const navigate = useNavigate();
  return (
    <>
      <Card
        key="department"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          מחלקות הרשות
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של מחלקות הרשות המקומית </Card.Title>
          <Card.Text>
            כל מכרז משויך למחלקה הרלוונטית, לכן צריך לוודא שכל מחלקות הרשות
            המקומית נמצאות ברשימה. לא ניתן למחוק מחלקה שמשויכים אליה מכרזים
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="department"
            onClick={() => navigate("/departments")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="place" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          מקומות וכתובות
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של מקומות </Card.Title>
          <Card.Text>
            רשימת המקומות שניתן לערוך בהן ישיבות, ניתן להוסיף קאורדינטות לוויז.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="place"
            onClick={() => navigate("/places")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card
        key="ptorreason"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          סיבות הפטור
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של סיבות הפטור מעריכת מכרז </Card.Title>
          <Card.Text>
            במקרה והרשות לא רוצה לערוך מכרז חיצוני או פנימי, היא צריכה לספק עילה
            מתוך רשימה זו.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="ptorreason"
            onClick={() => navigate("/ptorreasons")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card
        key="advtype"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          סוגי הפרסום
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של אמצעי הפרסום </Card.Title>
          <Card.Text>
            רשימת אמצעי הפרסום, לדוג' אינטרנט או עיתונות באופן כללי, עדיף להוסיף
            יותר פירוט ולרשום למשל ידיעות אחרונות, או שם האתר הספיציפי למשל אתר
            האינטרנט העירוני.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="advtype"
            onClick={() => navigate("/advtypes")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="mayor" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          ראשי הרשות
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימת ראשי הרשות המקומית </Card.Title>
          <Card.Text>
            כדי לתעד את שם ראש הרשות המכהן בתקופת עריכת המכרז
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="mayor"
            onClick={() => navigate("/mayors")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="hotem" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          רשימת החותמים
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימת החותמים על המכתבים </Card.Title>
          <Card.Text>
            רשימת החותמים כדי לתעד את תקופת החתימה על המכתבים, החותם הפעיל הוא
            החותם שנוסף אחרון.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="hotem"
            onClick={() => navigate("/hotmeem")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card
        key="jobtype"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          סוגי התפקיד
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימת הקטגוגריות של התפקיד </Card.Title>
          <Card.Text>
            כל תפקיד משויך לקטגוריה כללית כך שניתן לבחור את התפקיד בהתאם
            לקטגוריה.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="mayor"
            onClick={() => navigate("/jobtypes")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="job" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          תפקידים
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של התפקידים ברשות המקומית </Card.Title>
          <Card.Text>לשם בחירת התפקיד במכרז</Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="job"
            onClick={() => navigate("/jobs")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="eval" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          מכון מיון
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של מכונים לעריכת מבחנים </Card.Title>
          <Card.Text>
            רשימה של מכונים לעריכת מיון ומבחנים להערכת עובדים, מומלץ להגדיר את
            הרשות המקומית כמכון למיון מועמדים, כך שניתן להשתמש בו אם התהליך
            פנימי. <br />
            מכון מיון המתמחה באבחון ומיון מועמדים לעבודה, שהמציא לרשות המקומית
            חוות דעת של מורשה נגישות מבנים תשתיות וסביבה וחוות דעת של מורשה
            לנגישות השירות, ולפיהן המקום והשירות מותאמים לצרכים של מועמד עם
            מוגבלות.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="eval"
            onClick={() => navigate("/evaluationinstitute")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="hakala" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          סיבות להקלה
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של סיבות להקלה למועמדים במבחנים </Card.Title>
          <Card.Text>
            מועמד שהתקיימו בו כל אלה (1+2+3) , רשאי ראש הרשות המקומית להורות
            לגביו כי ייבחן בשפתו, למעט בבחינה בידיעת הלשון העברית, או שתינתן לו
            תוספת זמן במבחן, ראש הרשות רשאי להוסיף סיבות מיוחדות
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="hakala"
            onClick={() => navigate("/hakalareasons")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card
        key="nazeegtyoe"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          סוגי הנציגים בוועדות
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של סוגי הנציגים בוועדות </Card.Title>
          <Card.Text>
            רשימה שמפרטת את סוגי הנציגים היכולים להששתף בוועדת הבחינה של מכרז
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="nazeegtype"
            onClick={() => navigate("/nazeegtypes")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card
        key="members"
        style={{ maxWidth: "45rem" }}
        className="mb-2 mx-auto"
      >
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          חברי הוועדות
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של האנשים שיכולים לשמש כחברי ועדה </Card.Title>
          <Card.Text>
            העירייה יכולה לבחור מבין האנשים המופיעים בטבלה חברים שישתתפו בוועדה
            לשם בחירת ועדה לבחינת מועמדים
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="department"
            onClick={() => navigate("/members")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>

      <Card key="amot" style={{ maxWidth: "45rem" }} className="mb-2 mx-auto">
        <Card.Header
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}
        >
          אמות מידה
        </Card.Header>
        <Card.Body>
          <Card.Title>רשימה של אמות המידה במיון המקדים </Card.Title>
          <Card.Text>
            אמות מידה ענייניות, נוגעות למשרה ושוויוניות, שיש בהן כדי להעניק
            יתרון בבחינת התאמת המועמדים למשרה
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <Button
            variant="danger"
            value="amot"
            onClick={() => navigate("/amotmedacats")}
          >
            עריכת טבלה
          </Button>
        </Card.Footer>
      </Card>
    </>
  );
};

export default Tables;
